// Function to fetch all products from the specified collection
async function fetchAllProducts() {
    const response = await fetch('/collections/all-patchumz/products.json?limit=50');
    const data = await response.json();
    const products = data.products;
    const productsWithCollections = products.map(product => {
        const productCollections = collections.filter(collection => {
            return collection.products.some(colProduct => colProduct.id === product.id); // Checking if the product belongs to the collection
        });
        product.collections = productCollections.map(col => ({ handle: col.handle, title: col.title }));
        return product;
    });

    return productsWithCollections;
}

// Function to filter products based on selected filters
function filterProducts(products, filters) {
    if (filters.length === 0) {
        return products; // No filtering applied, return all products
    }
//console.log(filters);
    return products.filter(product => {
        // Check if the product is in a collection with a handle that matches one of the filters
        //console.log(product.collections.some(collection => filters.includes(collection.handle)));
        return product.collections.some(collection => filters.includes(collection.handle));
    });
}

// Function to sort products based on the selected sorting method
function sortProducts(products, sortBy) {
    if (sortBy === 'title-ascending') {
        return products.sort((a, b) => a.title.localeCompare(b.title));
    } else if (sortBy === 'title-descending') {
        return products.sort((a, b) => b.title.localeCompare(a.title));
    } else if (sortBy === 'price-ascending') {
        return products.sort((a, b) => parseFloat(a.variants[0].price) - parseFloat(b.variants[0].price));
    } else if (sortBy === 'price-descending') {
        return products.sort((a, b) => parseFloat(b.variants[0].price) - parseFloat(a.variants[0].price));
    } else if (sortBy === 'created-descending') {
        return products.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    } else if (sortBy === 'created-ascending') {
        return products.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
    } else {
        return products; // No sorting applied
    }
}

// Function to paginate the products
function paginateProducts(products, page = 1, perPage = 6) {
    const start = (page - 1) * perPage;
    const end = page * perPage;
    return products.slice(start, end);
}

// Function to render products in the product grid
function renderProducts(products, append = false) {
    const productGrid = document.getElementById('product-grid');
    let productHTML = '';

    products.forEach(product => {
        const productImage = product.images.length > 0 ? product.images[0].src : '';
        const productPrice = Number(product.variants[0].price);
        const compareAtPrice = Number(product.variants[0].compare_at_price);
        const formattedProductPrice = productPrice.toFixed(2);
        const formattedCompareAtPrice = compareAtPrice.toFixed(2);
        const category = product.collections.find(col => uniqueCollections.includes(col.handle) );
        productHTML += `
      <div class="product-item relative m-[30px]">
        <div class="absolute top-4 left-4 bg-[#D0EFF7] py-1 px-5 rounded-full" >
            <span class="font-bold text-[#557EBE]">${category.title}</span>
        </div>
        <a href="/products/${product.handle}">
          <img src="${productImage}" alt="${product.title}" class="w-full"/>
          <h2 class="mt-[25px] mb-[15px] normal-case text-left text-[22px] not-italic font-bold leading-[1.40625]">${product.title}</h2>`;
            if (compareAtPrice && compareAtPrice > productPrice) {
              productHTML += `
                <p class="text-lg" style="font-weight: 600;">
                  <span class="text-[#557EBE]">$${formattedProductPrice}</span> <span class="text-[#a0a0a0] text-lg line-through" style="margin-left: 15px; text-decoration-line: line-through !important;"> $${formattedCompareAtPrice} </span>
                </p>`;
            } else {
              productHTML += `
                <p class="text-[#557EBE] text-lg" style="font-weight: 600;">
                  $${formattedProductPrice}
                </p>`;
            }
        productHTML += `</a>
        <!-- <div data-pf-type="Block" class="sc-eBHgEO esEFmD pf-145_"><button data-product-id="7849162801324" data-checkout="same" data-soldout="Sold Out" data-adding="Adding..." data-added="Thank You!" name="add" type="button" data-pf-type="ProductATC2" class="sc-etlBSa jrUWva pf-146_ pf-button-1">Quick Add</button></div> -->
      </div>
    `;
    });

    if (append) {
        // Append new products to the existing ones
        productGrid.innerHTML += productHTML;
    } else {
        // Replace the entire product grid with new products
        productGrid.innerHTML = productHTML;
    }
}

// Main function to load products based on filters, sorting, and pagination
async function loadProducts(filters = [], sortBy = 'created-descending', page = 1, perPage = 20, append = false) {
    showLoading(); // Show loading spinner

    if ( filters.length === 0 ) {
        perPage = 6;
    }
    // Step 1: Fetch all products from the collection
    const products = await fetchAllProducts();

    // Step 2: Filter the products
    let filteredProducts = filterProducts(products, filters);

    // Step 3: Sort the products
    filteredProducts = sortProducts(filteredProducts, sortBy);

    updateProductCount(filteredProducts.length);

    // Step 4: Paginate the products
    const paginatedProducts = paginateProducts(filteredProducts, page, perPage);

    // Step 5: Render the products (append if needed)
    renderProducts(paginatedProducts, append);

    hideLoading();

    // Step 6: Handle "Show More" button visibility
    const hasMoreProducts = page * perPage < filteredProducts.length;
    const loadMoreButton = document.getElementById('load-more');
    if (hasMoreProducts) {
        loadMoreButton.style.display = 'inline-block';
    } else {
        loadMoreButton.style.display = 'none';
    }
}

// Function to update the selected filters UI
function updateSelectedFiltersUI() {
    const selectedFiltersDiv = document.getElementById('selected-filters');
    selectedFiltersDiv.innerHTML = ''; // Clear previous filters

    selectedFilters.forEach((filter, index) => {
        // Create a span for each selected filter with a remove button
        const filterSpan = document.createElement('span');
        filterSpan.className = 'filter-tag border border-1 border-gray-200 text-gray-800 px-2 py-1 rounded-lg mr-2 mb-2 inline-block';
        const collection = collections.find(col => col.handle === filter);
        filterSpan.innerHTML = `${collection.title} <button class="remove-filter" data-index="${index}">&times;</button>`;
        selectedFiltersDiv.appendChild(filterSpan);
    });

    // Add event listeners for removing filters
    const removeButtons = document.querySelectorAll('.remove-filter');
    removeButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            const filterIndex = event.target.getAttribute('data-index');
            removeFilter(filterIndex);
        });
    });
}
// Function to handle filter button click
function handleFilterClick(event) {
    const filterHandle = event.currentTarget.getAttribute('data-collection-handle');

    selectedFilters = [];
    // Check if the filter is already selected
    const filterIndex = selectedFilters.indexOf(filterHandle);
    if (filterIndex === -1) {
        // If not selected, add it
        selectedFilters.push(filterHandle);
    } else {
        // If selected, remove it
        selectedFilters.splice(filterIndex, 1);
    }

    // Update the selected filters UI
    updateSelectedFiltersUI();

    // Reload products with updated filters
    currentPage = 1; // Reset to the first page
    loadProducts(selectedFilters, selectedSortBy, currentPage);
}

// Function to remove a filter by index
function removeFilter(index) {
    selectedFilters.splice(index, 1); // Remove the filter
    updateSelectedFiltersUI(); // Update the UI
    currentPage = 1;
    loadProducts(selectedFilters, selectedSortBy, currentPage); // Reload products
}

// Function to show a loading animation
function showLoading() {
    const loader = document.getElementById('loader');
    const productGrid = document.getElementById('product-grid');
    loader.classList.add('block'); // Show the loading animation
    loader.classList.remove('hidden');
    productGrid.classList.add('hidden');
    productGrid.classList.remove('grid');
}

// Function to hide the loading animation
function hideLoading() {
    const loader = document.getElementById('loader');
    const productGrid = document.getElementById('product-grid');
    loader.classList.remove('block');
    loader.classList.add('hidden');
    productGrid.classList.remove('hidden');
    productGrid.classList.add('grid');
}

// Function to update the product count
function updateProductCount(totalCount) {
    const resultsCount = document.getElementById('results-count');
    resultsCount.textContent = totalCount;
}

// Event listener for the "Show More" button
let currentPage = 1;
document.getElementById('load-more').addEventListener('click', () => {
    currentPage++;
    loadProducts(selectedFilters, selectedSortBy, currentPage,6, true);
});

// Example initial load with default filters and sorting
let selectedFilters = []; // Modify this based on your filter UI (e.g., selected tags)
let selectedSortBy = 'created-descending'; // Modify this based on your sorting UI (e.g., dropdown)

document.addEventListener('DOMContentLoaded', () => {
    loadProducts(selectedFilters, selectedSortBy, 1); // Load the first page of products on page load
});

// Event listener for changes in the sort-by dropdown
document.getElementById('sort-options').addEventListener('change', (event) => {
    selectedSortBy = event.target.value; // Update the selected sorting method
    currentPage = 1; // Reset to the first page when sorting changes
    loadProducts(selectedFilters, selectedSortBy, currentPage); // Reload products with the new sorting method
});

const filterButtons = document.querySelectorAll('.filter-btn');
filterButtons.forEach(button => {
    button.addEventListener('click', handleFilterClick);
});

